import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import "./RestaurantCard.css";

const RestaurantCard = ({ restaurant }) => {
  return (
    <Link to={`/menu?restaurant=${restaurant.id}`} className="restaurant-card">
      <div className="restaurant-img-wrapper">
        <img src={restaurant.image} alt={restaurant.name} className="restaurant-img" loading="lazy" />
        <div className="restaurant-badge-top">{restaurant.status}</div>
        {restaurant.discount && <div className="restaurant-badge-discount">{restaurant.discount}</div>}
      </div>
      
      <div className="restaurant-details">
        <h3 className="restaurant-name">{restaurant.name}</h3>
        <p className="restaurant-cuisine">{restaurant.cuisine}</p>
        
        <div className="restaurant-meta">
          <span className="restaurant-rating">
            <Icon icon="mdi:star" />
            {restaurant.rating} ({restaurant.reviews}+)
          </span>
          <span>•</span>
          <span><Icon icon="mdi:clock-outline" /> {restaurant.time}</span>
          <span>•</span>
          <span style={{color: 'var(--success)'}}><Icon icon="mdi:moped-outline" /> Free</span>
        </div>
        
        <div className="restaurant-price">
          ₹{restaurant.costForTwo} for two
        </div>
      </div>
      
      <div className="restaurant-overlay-btn">
        View Menu →
      </div>
    </Link>
  );
};

export default RestaurantCard;
